<template>
  <div class="CartLoading flex flex-middle px-8">
    <div class="mr-8" style="font-size: 90px">
      <i class="fal fa-spinner-third fa-spin"></i>
    </div>
    <div class="CartLoading__wait text-2xl">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "Cart.Loading",
}
</script>

<style>
.CartLoading {
  position: absolute;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.7);
  backdrop-filter: blur(4px);
  z-index: 10000;
}

.CartLoading__wait {
  max-width: 230px;
}
</style>
